import Raven from 'raven-js';
// @ts-expect-error no declarations found for module
import { isAcceptanceTest } from 'hub-http/helpers/env';
import { getContentEditorPreviewIframe, getContentEditorSidebarIframe
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/utils/inpageUtils';
import { prefixKeys } from 'EmailEditorUI/utils/helpers';
// taken from https://stackoverflow.com/a/1981366
function stripRepeatedWhitespace(str = '') {
  return str.replace(/\s\s+/g, ' ');
}
function parseStacktracedError(message, type = 'Unspecified Error') {
  // Strip any meaningless characters or strings from JS exceptions.
  return `${type}: ${stripRepeatedWhitespace(message)}`;
}
function getInitialVisibility() {
  const [initialVisibility] = performance.getEntriesByType('visibility-state');
  return initialVisibility === null || initialVisibility === void 0 ? void 0 : initialVisibility.name;
}
function getCorrelationId(searchString) {
  var _entries$;
  const performanceResourceTimings = performance.getEntriesByType('resource').filter(({
    name
  }) => name.includes(searchString));
  const entries = performanceResourceTimings.flatMap(timing => timing.serverTiming.filter(serverTiming => serverTiming.name === 'hcid'));
  return (_entries$ = entries[0]) === null || _entries$ === void 0 ? void 0 : _entries$.description;
}
function ravenDataCallback(data, original) {
  var _data$extra;
  // If the raven request already has a fingerprint, it has already been handled by
  // upstream from us by either our own network failure catches or by other FE tools
  // (e.g. usage tracking), and doesn't need to be assigned a fingerprint
  if (!data.fingerprint && !data.isPageEvent) {
    // The gist of the logic here is that we continuously try and find network errors through:
    // - `data` having an `exception` where a URL is mentioned in the first line
    // - `data` having a `message` where a URL is mentioned in the first line
    let fingerprint;
    if (data.exception && data.exception.values && data.exception.values.length > 0) {
      const [exception] = data.exception.values;
      fingerprint = [parseStacktracedError(exception.value, exception.type)];
    } else {
      fingerprint = [parseStacktracedError(data.message)];
    }
    // Ignore default grouping behaviour and go solely off our scrubbed error message
    data.fingerprint = fingerprint;
  }
  (_data$extra = data.extra) !== null && _data$extra !== void 0 ? _data$extra : data.extra = {};
  data.extra.fingerprint = data.fingerprint;
  if (data.extra.failureType === 'watchdogExpired') {
    var _getContentEditorPrev, _getContentEditorSide;
    if (window.hsQueuedLifecycleTimestamps) {
      Object.assign(data.extra, prefixKeys('epLifecycle', window.hsQueuedLifecycleTimestamps));
    }
    const emailExtras = {};
    emailExtras.previewIframeUrl = (_getContentEditorPrev = getContentEditorPreviewIframe()) === null || _getContentEditorPrev === void 0 ? void 0 : _getContentEditorPrev.src;
    emailExtras.sidebarIframeUrl = (_getContentEditorSide = getContentEditorSidebarIframe()) === null || _getContentEditorSide === void 0 ? void 0 : _getContentEditorSide.src;
    emailExtras.combinedEditDataCid = getCorrelationId('combined-edit-data');
    emailExtras.hasPreviewIframeRequest = performance.getEntriesByType('resource').filter(entry => entry.initiatorType === 'iframe' && entry.name.includes('hcms/preview')).length > 0;
    Object.assign(data.extra, prefixKeys('email', emailExtras));
  }
  return original ? original(data) : data;
}
function setShouldSendCallback() {
  if (isAcceptanceTest()) {
    window.addEventListener('beforeunload', () => {
      Raven.setShouldSendCallback(data => {
        if (data.exception) {
          return !navigator.userAgent.includes('Firefox');
        }
        return true;
      });
    });
  }
}
export function configureRavenDefaultContext({
  user
}, {
  extra = {}
} = {}) {
  Raven.setExtraContext(Object.assign({
    initialVisibility: getInitialVisibility(),
    userId: user.user_id
  }, extra));
  Raven.setUserContext({
    id: user.user_id.toString(),
    email: user.email,
    // @ts-expect-error leaving this same as it was set up in JS
    locale: user.locale
  });
  Raven.setDataCallback(ravenDataCallback);
  setShouldSendCallback();
}